module.exports = __webpack_public_path__ + "img/180.62200e23.jpg";